import { useLanguage } from '@/lib/i18n';
import { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import RecognitionDialog from './RecognitionDialog';

const RecognitionSection = () => {
  const { tr } = useLanguage();
  const [open, setOpen] = useState(false);
  return (
    <section id="recognition" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground">
            {tr('recognition.title')}
          </h2>
          <p className="mt-4 text-muted-foreground text-lg">
            {tr('recognition.subtitle')}
          </p>
        </div>
        <div className="text-center mb-8">
          <Button size="lg" className="text-base font-semibold gap-2" onClick={() => setOpen(true)}>
            {tr('recognition.cta')}
            <ArrowRight className="w-4 h-4" />
          </Button>
        </div>
        <RecognitionDialog open={open} onOpenChange={setOpen} />
      </div>
    </section>
  );
};

export default RecognitionSection;
